import React from 'react';

const Experience = () => {
  return (
    <section id="experience">
      <div className="wrap">
        <div className="eyebrow"><span className="prompt">$</span> git log --oneline --reverse</div>
        <h2 className="section-title">Experience</h2>
        <p className="section-sub">A working history, most recent first — except this is reverse-chronological order in spirit only; scroll for the full timeline.</p>

        <div className="timeline reveal">
          <div className="tl-item current">
            <div className="tl-head">
              <span className="tl-role">Backend Engineer</span>
              <span className="tl-date">Nov 2024 — Present</span>
            </div>
            <span className="tl-org">Nawo · Lagos (Remote) · Fintech</span>
            <ul className="tl-list">
              <li>Built and maintained backend services serving 400+ users and processing 300+ transactions for a "money spraying" feature that sends funds to multiple recipients during live events.</li>
              <li>Developed secure RESTful APIs for authentication, wallet funding, and sending/receiving funds.</li>
              <li>Designed and tuned database schemas and queries to keep latency low under peak traffic.</li>
              <li>Implemented validation, limits, and error handling to minimize failed transactions during high-traffic events.</li>
            </ul>
          </div>

          <div className="tl-item current">
            <div className="tl-head">
              <span className="tl-role">Fullstack Developer</span>
              <span className="tl-date">Jan 2024 — Present</span>
            </div>
            <span className="tl-org">Blended Technology Solutions · Lagos (Remote)</span>
            <ul className="tl-list">
              <li>Develop backend services using C# (.NET) and Node.js for internal and client-facing applications.</li>
              <li>Redesigned the company's landing page with modern HTML, CSS, and React.</li>
              <li>Work across the stack, integrating C#, Node.js, and React.js to ship end-to-end features.</li>
            </ul>
          </div>

          <div className="tl-item current">
            <div className="tl-head">
              <span className="tl-role">Co-Founder &amp; Backend Developer</span>
              <span className="tl-date">Sep 2022 — Present</span>
            </div>
            <span className="tl-org">UniXP · Akure · EdTech Startup</span>
            <ul className="tl-list">
              <li>Co-founded an edtech startup; built backend services with Node.js and APIs for app features.</li>
              <li>Created a download, waitlist, contact, and feedback site using PHP and CSS.</li>
            </ul>
          </div>

          <div className="tl-item">
            <div className="tl-head">
              <span className="tl-role">NYSC — Web Development Instructor &amp; LMS Developer</span>
              <span className="tl-date">Jul 2025 — May 2026</span>
            </div>
            <span className="tl-org">MIC, Governor's Office · Oyo State</span>
            <ul className="tl-list">
              <li>Taught web development to students as part of National Youth Service Corps placement.</li>
              <li>Built a Learning Management System (LMS) for IT students to track progress, manage tasks, and grade submissions — now in production at mic-lms.vercel.app.</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;